module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_sp_004-2acdcb3f6e742d0f2e2ca6bb6f1cd0e3.png";